import headerMenu from "./src/header-menu";
import accessibility from "./src/accessibility";
import filterRedirectInit from "./src/filter";
import initSafeMailDisplay from "./src/safe-mail";
import addBackupToPdfLinks from "./src/pdf-links";

window.addEventListener('DOMContentLoaded', function() {
	// Header menu
	headerMenu.init();

	// Accessibility options
	accessibility.init();

	// Filter automatic redirection
	filterRedirectInit();

	// Display emails and avoiding spam
	initSafeMailDisplay();

	addBackupToPdfLinks();

});